import SelfCustodyViaWeb3Auth from "./SelfCustodyViaWeb3Auth";

export default function Footer() {
  return (
    <div className="w3a-modal__footer">
      <div className="w3a-footer">
        <div>
          <div>
            <SelfCustodyViaWeb3Auth />
          </div>
        </div>
      </div>
    </div>
  );
}
